import { useState } from 'react';
import { Spinner } from '../../../../../assets/icon/svg';
import { useGetIndustriesQuery } from '../../../../../api/gms/group-category/group-category-api';
import IndustriesCategory from './industries-category';
import IndustriesItems from './industries-items';
import { useDispatch } from 'react-redux';
import { clearTypeModal } from '../../../../../features/gms-state-and-modal/modal-slice';
import { getErrorMessage } from '../../../../../utils/get-error-message.utils';
import CloseButtonModal from '../../../../ui/close-button-modal';

export default function NatureOfBusiness() {
    const dispatch = useDispatch();

    const {
        data: industries,
        isLoading: isLoadingIndustries,
        isError: isErrorIndustries,
        error: errorIndustries,
    } = useGetIndustriesQuery();

    const errorMessage = getErrorMessage(errorIndustries);

    const [view, setView] = useState<'category' | 'item'>('category');
    const [searchValue, setSearchValue] = useState<string>('');

    const handleClose = () => {
        dispatch(clearTypeModal());
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-3 sm:p-4">
            <div className="flex w-full max-w-4xl flex-col overflow-hidden rounded bg-white shadow-xl max-h-[90vh] min-h-[60vh] lg:w-[60%] " >
                {/* HEADER */}
                <div className="sticky top-0 z-20 flex items-center justify-between border-b border-gray-200 bg-white px-4 py-3 sm:px-5 sm:py-4 " >
                    <div className="flex flex-col">
                        <p className="text-sm font-semibold text-gray-800 sm:text-base">
                            Nature of Business List
                        </p>
                        <p className="text-xs text-gray-500">
                            Select nature of business
                        </p>
                    </div>
                    <CloseButtonModal handleClose={handleClose} />
                </div>
                {/* CONTENT */}
                <div className="flex-1 overflow-hidden p-3 sm:p-4 md:p-5">
                    {isLoadingIndustries ? (
                        <div className="flex min-h-[300px] w-full items-center justify-center">
                            <div className="flex items-center justify-center">
                                <Spinner
                                    color="#186cb2"
                                    size={30}
                                />
                                <span className="ml-2 text-xs text-gray-500">
                                    Loading...
                                </span>
                            </div>
                        </div>
                    ) : isErrorIndustries ? (
                        <div className="flex min-h-[300px] w-full items-center justify-center">
                            <div className="rounded border border-red-200 bg-red-50 px-4 py-3">
                                <p className="text-center text-xs text-red-600">
                                    {errorMessage}
                                </p>
                            </div>
                        </div>
                    ) : (
                        <div className="h-full min-h-0">
                            {view === 'category' && (
                                <IndustriesCategory
                                    setView={setView}
                                    industries={industries}
                                />
                            )}
                            {view === 'item' && (
                                <IndustriesItems
                                    setView={setView}
                                    setSearchValue={setSearchValue}
                                    searchValue={searchValue}
                                    industries={industries}
                                />
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}